/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {advanceChangeProposal} from '../api'

export const useMutationAdvanceChangeProposal = createReactQueryMutationHook('advanceChangeProposal', advanceChangeProposal)
